module.exports = __webpack_public_path__ + "img/menu_btn.8b9f6558.png";